// eslint-disable-next-line
// @ts-ignore
import('./containers/App/bootstrap')
// import('./containers/App/App')
